'use strict';

export default class OnlineFeedback {
    constructor(){
        this.togglePhoneMandatory();
        this.toogleEmailMandatory();
        this.toogleAddressMandatory();
        this.toogleContactPreferrenceMandatory();

        var self = this;

        $('.online-feedback-form [name="ContactPreferrenceType"]').change(function(){

            //make the phone required when the phone is selected as the preferrence 
            
            self.togglePhoneMandatory();
            self.toogleEmailMandatory();
            self.toogleAddressMandatory();
        });

        $('.online-feedback-form [name="ResponseType"]').change(function(){

            //make contact option appears if the users wants to get the responds.
            
            self.toogleContactPreferrenceMandatory();
        });


        $('.online-feedback-form #DoNotHaveEmailAddress').change(function(){
            if(!this.checked){
                $('.online-feedback-form').find('#EmailAddress').removeAttr('disabled');
                $('.online-feedback-form').find('#ConfirmEmailAddress').removeAttr('disabled');
                $('.online-feedback-form').find('#EmailAddressLabel').text('Email address*');
                $('.online-feedback-form').find('#ConfirmEmailAddressLabel').text('Confirm email address*');
                
            }else{
                $('.online-feedback-form').find('#EmailAddress').attr('disabled',true);
                $('.online-feedback-form').find('#EmailAddress').val('');
                $('.online-feedback-form').find('#ConfirmEmailAddress').attr('disabled',true);
                $('.online-feedback-form').find('#ConfirmEmailAddress').val('');
                
                $('.online-feedback-form').find('#EmailAddressLabel').text('Email address');
                $('.online-feedback-form').find('#ConfirmEmailAddressLabel').text('Confirm email address');
            }
            
            
        });

        

    }
    togglePhoneMandatory(){
        if($('.online-feedback-form [name="ContactPreferrenceType"]:checked').val() == 'Phone'){
           $('.online-feedback-form').find('#PhoneNumber').prop('required',true);
           $('.online-feedback-form').find('#PhoneNumberLabel').text('Your phone number*');
        }else{
          $('.online-feedback-form').find('#PhoneNumber').removeAttr('required');
          $('.online-feedback-form').find('#PhoneNumberLabel').text('Your phone number');
        }
    }

    toogleEmailMandatory(){
        if($('.online-feedback-form [name="ContactPreferrenceType"]:checked').val() == 'Email'){
            $('.online-feedback-form #DoNotHaveEmailAddress').prop('checked',false);
            $('.online-feedback-form #DoNotHaveEmailAddress').attr('disabled',true);
            $('.online-feedback-form').find('#EmailAddress').removeAttr('disabled');
            $('.online-feedback-form').find('#ConfirmEmailAddress').removeAttr('disabled');
         }else{
            $('.online-feedback-form #DoNotHaveEmailAddress').attr('disabled',false);
            if(!$('.online-feedback-form #DoNotHaveEmailAddress').checked){
            
                $('.online-feedback-form').find('#EmailAddressLabel').text('Email address*');
                $('.online-feedback-form').find('#ConfirmEmailAddressLabel').text('Confirm email address*');
                
            }else{
                $('.online-feedback-form').find('#EmailAddressLabel').text('Email address');
                $('.online-feedback-form').find('#ConfirmEmailAddressLabel').text('Confirm email address');
            }
         }
         

    }

    toogleAddressMandatory(){
        
        var parentWrapper = $('.online-feedback-form .address-wrapper');


        if($('.online-feedback-form [name="ContactPreferrenceType"]:checked').val() == 'Post'){
            $('.online-feedback-form').find('.postalAddressHeading').text('Postal address*');
            $('.online-feedback-form').find('.residentialAddressHeading').text('Residential address*');
            
            
            parentWrapper.find('.postcode-input').prop('required',true);
            parentWrapper.find('.suburb-input').prop('required',true);
            parentWrapper.find('.address-line-1').prop('required',true);
            
           
            
        }else{
            $('.online-feedback-form').find('.postalAddressHeading').text('Postal address');
            $('.online-feedback-form').find('.residentialAddressHeading').text('Residential address');
            
            parentWrapper.find('.address-line-1').removeAttr('required');
            parentWrapper.find('.suburb-input').removeAttr('required');
            parentWrapper.find('.postcode-input').removeAttr('required');
              
           
        }
    }

    toogleContactPreferrenceMandatory(){
        
        if($('.online-feedback-form [name="ResponseType"]:checked').val() == 'Yes'){
            $('.online-feedback-form').find('.preference-group').show();
            $('.online-feedback-form').find('.preference-group .button-text:nth-child(1) [name="ContactPreferrenceType"]').prop('required',true);
        }else{
            $('.online-feedback-form').find('.preference-group').hide();
            $('.online-feedback-form').find('.preference-group .button-text [name="ContactPreferrenceType"]').prop('checked',false);
            
            $('.online-feedback-form').find('.preference-group .button-text:nth-child(1) [name="ContactPreferrenceType"]').removeAttr('required');
            this.togglePhoneMandatory();
            this.toogleEmailMandatory();
            this.toogleAddressMandatory();
        }

        
    }
}